module.exports = __webpack_public_path__ + "resources/img/img-zenius-apm-02-m-jp.bdb4e71dc5ecdad56d0ac7cf6b546a7c.png";